/**
 * EastSupplier Insights CTA — sky, clouds, paper plane & arc trails
 */
(function () {
  'use strict';

  function initInsightsCanvas(root) {
    if (root.dataset.esCanvasInit === '1') return;
    root.dataset.esCanvasInit = '1';

    var canvas = root.querySelector('[data-insights-canvas]');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0;
    var h = 0;
    var layState = { lastW: 0, lastH: 0 };
    var time = 0;
    var rafId = null;
    var running = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var clouds = [];
    var trailPoints = [];
    var lastCycleP = null;
    var flightPath = null;
    var TRAIL_MAX = 110;
    var TRAIL_MIN_DIST = 3;

    function rand(a, b) {
      return a + Math.random() * (b - a);
    }

    function buildClouds() {
      clouds = [];
      var n = Math.max(4, Math.floor(w / 200));
      for (var i = 0; i < n; i++) {
        clouds.push({
          x: rand(0, w),
          y: rand(h * 0.05, h * 0.45),
          s: rand(0.5, 1.2),
          sp: rand(0.06, 0.18)
        });
      }
    }

    function resize() {
      var L = window.EastSupplierCanvasLayout;
      if (L) {
        var m = L.measure(canvas, root, { minW: 320, minH: 220, state: layState });
        w = m.w;
        h = m.h;
        dpr = m.dpr;
        L.applyBitmap(canvas, ctx, w, h, dpr);
      } else {
        var rect = (canvas.parentElement || root).getBoundingClientRect();
        w = Math.max(320, rect.width);
        h = Math.max(220, rect.height);
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.floor(w * dpr);
        canvas.height = Math.floor(h * dpr);
        if (canvas.style) {
          canvas.style.width = '';
          canvas.style.height = '';
        }
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      buildClouds();
      newFlightPath();
      resetTrail();
    }

    /** Random cubic-bezier arc: bottom-left → top-right */
    function newFlightPath() {
      var startX = rand(w * 0.04, w * 0.14);
      var startY = rand(h * 0.78, h * 0.92);
      var endX = rand(w * 0.86, w * 0.97);
      var endY = rand(h * 0.1, h * 0.28);

      flightPath = {
        p0: { x: startX, y: startY },
        p1: {
          x: rand(w * 0.15, w * 0.45),
          y: rand(h * 0.08, h * 0.55)
        },
        p2: {
          x: rand(w * 0.5, w * 0.82),
          y: rand(h * 0.45, h * 0.95)
        },
        p3: { x: endX, y: endY }
      };
    }

    function bezierPoint(path, t) {
      var u = 1 - t;
      var u2 = u * u;
      var t2 = t * t;
      var u3 = u2 * u;
      var t3 = t2 * t;

      return {
        x:
          u3 * path.p0.x +
          3 * u2 * t * path.p1.x +
          3 * u * t2 * path.p2.x +
          t3 * path.p3.x,
        y:
          u3 * path.p0.y +
          3 * u2 * t * path.p1.y +
          3 * u * t2 * path.p2.y +
          t3 * path.p3.y
      };
    }

    function bezierAngle(path, t) {
      var u = 1 - t;
      var dx =
        3 * u * u * (path.p1.x - path.p0.x) +
        6 * u * t * (path.p2.x - path.p1.x) +
        3 * t * t * (path.p3.x - path.p2.x);
      var dy =
        3 * u * u * (path.p1.y - path.p0.y) +
        6 * u * t * (path.p2.y - path.p1.y) +
        3 * t * t * (path.p3.y - path.p2.y);
      return Math.atan2(dy, dx);
    }

    function planePos(t) {
      if (!flightPath) newFlightPath();

      var p = reducedMotion ? 0.38 : (t * 0.1) % 1;
      var pos = bezierPoint(flightPath, p);
      var angle = bezierAngle(flightPath, p);

      return { x: pos.x, y: pos.y, angle: angle, p: p };
    }

    function drawSky() {
      var g = ctx.createLinearGradient(0, 0, 0, h);
      g.addColorStop(0, '#7ec4f2');
      g.addColorStop(0.45, '#a8daf8');
      g.addColorStop(1, '#d4ecfa');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
    }

    function drawCloud(c) {
      ctx.save();
      ctx.globalAlpha = 0.88;
      ctx.fillStyle = '#fff';
      var s = 28 * c.s;
      function puff(px, py, r) {
        ctx.beginPath();
        ctx.arc(px, py, r, 0, Math.PI * 2);
        ctx.fill();
      }
      puff(c.x, c.y, s * 0.5);
      puff(c.x - s * 0.5, c.y + 2, s * 0.38);
      puff(c.x + s * 0.45, c.y + 1, s * 0.42);
      ctx.restore();
    }

    function drawClouds(dt) {
      clouds.forEach(function (c) {
        if (!reducedMotion) c.x += c.sp * dt * 22;
        if (c.x > w + 80) c.x = -80;
        drawCloud(c);
      });
    }

    function resetTrail() {
      trailPoints = [];
    }

    function pushTrailPoint(x, y) {
      var last = trailPoints[trailPoints.length - 1];
      if (last) {
        var dx = x - last.x;
        var dy = y - last.y;
        if (dx * dx + dy * dy < TRAIL_MIN_DIST * TRAIL_MIN_DIST) return;
      }
      trailPoints.push({ x: x, y: y });
      if (trailPoints.length > TRAIL_MAX) trailPoints.shift();
    }

    /** Single smooth contrail through recorded flight path */
    function drawSmoothTrail() {
      var n = trailPoints.length;
      if (n < 2) return;

      ctx.save();
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';

      ctx.beginPath();
      ctx.moveTo(trailPoints[0].x, trailPoints[0].y);

      for (var i = 1; i < n - 1; i++) {
        var xc = (trailPoints[i].x + trailPoints[i + 1].x) * 0.5;
        var yc = (trailPoints[i].y + trailPoints[i + 1].y) * 0.5;
        ctx.quadraticCurveTo(trailPoints[i].x, trailPoints[i].y, xc, yc);
      }

      ctx.lineTo(trailPoints[n - 1].x, trailPoints[n - 1].y);

      var head = trailPoints[n - 1];
      var tail = trailPoints[0];
      var grad = ctx.createLinearGradient(tail.x, tail.y, head.x, head.y);
      grad.addColorStop(0, 'rgba(255, 255, 255, 0)');
      grad.addColorStop(0.25, 'rgba(180, 220, 255, 0.25)');
      grad.addColorStop(0.65, 'rgba(255, 255, 255, 0.55)');
      grad.addColorStop(1, 'rgba(255, 255, 255, 0.92)');

      ctx.strokeStyle = grad;
      ctx.lineWidth = 2.8;
      ctx.stroke();

      ctx.strokeStyle = 'rgba(100, 175, 255, 0.22)';
      ctx.lineWidth = 5;
      ctx.stroke();

      ctx.restore();
    }

    function drawPlane(x, y, angle) {
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);

      ctx.fillStyle = 'rgba(255,255,255,0.95)';
      ctx.strokeStyle = 'rgba(90, 150, 210, 0.5)';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(22, 0);
      ctx.lineTo(-14, -8);
      ctx.lineTo(-8, 0);
      ctx.lineTo(-14, 8);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();

      ctx.fillStyle = 'rgba(255, 180, 120, 0.35)';
      ctx.beginPath();
      ctx.moveTo(8, 0);
      ctx.lineTo(-6, -12);
      ctx.lineTo(-2, 0);
      ctx.lineTo(-6, 12);
      ctx.closePath();
      ctx.fill();

      ctx.restore();
    }

    function frame(ts) {
      if (!running) return;
      var expectedW = Math.max(1, Math.floor(w * dpr));
      if (canvas.width < expectedW * 0.5 || canvas.height < Math.max(1, Math.floor(h * dpr)) * 0.5) {
        resize();
      }
      var dt = 0.016;
      if (!reducedMotion) time = ts * 0.001;

      var plane = planePos(time);

      if (lastCycleP !== null && plane.p < lastCycleP - 0.05) {
        newFlightPath();
        resetTrail();
      }
      lastCycleP = plane.p;

      var tailX = plane.x - Math.cos(plane.angle) * 14;
      var tailY = plane.y - Math.sin(plane.angle) * 14;
      if (!reducedMotion) {
        pushTrailPoint(tailX, tailY);
      } else if (trailPoints.length === 0) {
        pushTrailPoint(tailX, tailY);
      }

      ctx.clearRect(0, 0, w, h);
      drawSky();
      drawClouds(dt);
      drawSmoothTrail();
      drawPlane(plane.x, plane.y, plane.angle);

      rafId = requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      resize();
      running = true;
      rafId = requestAnimationFrame(frame);
    }

    function stop() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
    }

    resize();
    window.addEventListener('resize', resize);

    if (typeof ResizeObserver !== 'undefined' && canvas.parentElement) {
      new ResizeObserver(function () {
        resize();
      }).observe(canvas.parentElement);
    }

    requestAnimationFrame(function () {
      resize();
    });

    start();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            resize();
            start();
          } else stop();
        });
      }).observe(root);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else {
        resize();
        var br = root.getBoundingClientRect();
        if (br.bottom > 0 && br.top < window.innerHeight) start();
      }
    });

    window.addEventListener('pageshow', function () {
      resize();
      start();
    });
  }

  function boot() {
    document.querySelectorAll('[data-es-insights-canvas]').forEach(initInsightsCanvas);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
